module.exports = __webpack_public_path__ + "img/dump.904c4482.svg";